import LanguageModal from './LanguageModal';

export default LanguageModal;